import { useTranslation } from 'react-i18next';
import { GroupBarSize } from '../../../api/generated';
import styles from '../WeekEditorPanel.module.css';

const BAR_SIZE_OPTIONS: GroupBarSize[] = [GroupBarSize.Small, GroupBarSize.Medium, GroupBarSize.Large];

interface BarSizePickerProps {
  value: GroupBarSize;
  strokeColor: string;
  fillColor: string;
  onChange: (size: GroupBarSize) => void;
}

export const BarSizePicker = ({ value, strokeColor, fillColor, onChange }: BarSizePickerProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.barSizePicker} role="radiogroup" aria-label={t('config-group-bar-size')}>
      {BAR_SIZE_OPTIONS.map((size) => (
        <button
          key={size}
          type="button"
          role="radio"
          aria-checked={value === size}
          className={`${styles.barSizeOption} ${value === size ? styles.barSizeOptionActive : ''}`}
          onClick={() => onChange(size)}
          title={t(`config-group-bar-size-${size.toLowerCase()}`)}
        >
          <span
            className={`${styles.barSizeSample} ${styles[`barSizeSample_${size.toLowerCase()}`]}`}
            style={{ backgroundColor: fillColor, border: `1px solid ${strokeColor}` }}
          />
        </button>
      ))}
    </div>
  );
};
